{
  "nargs": 7,
  "nin": 1,
  "nout": 1
}
